import { IClickElement } from './base-element';
import { Confirm } from './confirm';
import { ElementType } from './element-type';
import { Input } from './input';
import { Modal } from './modal';

export class Signature extends Input implements IClickElement {
  pageRequests: any[] = [];
  constructor() {
    super('');
    this.elementType = ElementType.signature;
  }
  confirmAction: Confirm | null = null;
  modalAction: Modal | null = null;
}
